import { NAV_LINKS } from "../../data/content";

export const Footer = () => {
  return (
    <footer
      data-testid="footer"
      className="border-t px-6 py-12 lg:px-10"
      style={{ borderColor: "var(--border)" }}
    >
      <div className="mx-auto flex max-w-7xl flex-col items-start justify-between gap-8 md:flex-row md:items-center">
        <div>
          <p className="font-head text-xl text-[color:var(--text)]">Graham Wetzbarger</p>
          <p className="font-accent mt-1 text-[11px] uppercase tracking-[0.2em] text-[color:var(--text-2)]">
            Luxury Authentication · Appraisal · Advisory
          </p>
        </div>
        <div className="flex flex-wrap gap-x-7 gap-y-2">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="text-[11px] uppercase tracking-[0.18em] text-[color:var(--text-2)] transition-colors hover:text-[color:var(--text)]"
            >
              {l.label}
            </a>
          ))}
        </div>
      </div>
      <div
        className="mx-auto mt-10 max-w-7xl border-t pt-6"
        style={{ borderColor: "var(--border)" }}
      >
        <p className="text-[11px] text-[color:var(--text-2)]">
          © {new Date().getFullYear()} Graham Wetzbarger. All rights reserved.
        </p>
      </div>
    </footer>
  );
};
